import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=35f2b466&scoped=true&lang=pug&"
import script from "./modal.ts?vue&type=script&lang=ts&"
export * from "./modal.ts?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=35f2b466&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2b466",
  null
  
)

export default component.exports